import { render, staticRenderFns } from "./counters.vue?vue&type=template&id=34127e96&scoped=true&"
import script from "./counters.vue?vue&type=script&lang=js&"
export * from "./counters.vue?vue&type=script&lang=js&"
import style0 from "./counters.vue?vue&type=style&index=0&id=34127e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34127e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34127e96')) {
      api.createRecord('34127e96', component.options)
    } else {
      api.reload('34127e96', component.options)
    }
    module.hot.accept("./counters.vue?vue&type=template&id=34127e96&scoped=true&", function () {
      api.rerender('34127e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/counters.vue"
export default component.exports